(() => {
	'use strict';

	angular.module('bmsApp.instantMessaging')
		.controller('InstantMessagingCtrl', InstantMessagingCtrl);

	InstantMessagingCtrl.$inject = [
		'$scope',
		'$rootScope',
		'$q',
		'$location',
		'$timeout',
		'$filter',
		'Focus',
		'notify',
		'AuthService',
		'InstantMessagingRepository',
	];

	function InstantMessagingCtrl(
		$scope,
		$rootScope,
		$q,
		$location,
		$timeout,
		$filter,
		Focus,
		notify,
		AuthService,
		InstantMessagingRepository,
	) {
		let self = this;
		let handlers = {};
		let echo = null;

		angular.extend(self, {
			init: init,
			handlers: handlers,
			// View
			enabled: false,
			expanded: false,
			visible: false,
			// Conversation
			users: [],
			conversations: [],
			conversation: null,
			totalUnreadMessageCount: 0,
		});

		function init() {
			// This option is for disabling IM locally only because the socket connection error can be annoying.
			if (!window.config.app.instant_messaging_enabled) {
				return;
			}
			self.enabled = true;
			// Initiate Echo library
			let laravelEchoServerUrl = window.config.app.worker_url + ':' + window.config.app.instant_messaging_socket_port;
			echo = new Echo({
				broadcaster: 'socket.io',
				host: laravelEchoServerUrl,
			});

			let promises = {
				conversations: InstantMessagingRepository.conversations(),
				currentUser: AuthService.getUser()
			};
			$q.all(promises).then(function (responses) {

				// Current user
				self.user = new ChatUser();
				self.user.id = responses.currentUser.id;
				self.user.name = responses.currentUser.first_name + ' ' + responses.currentUser.last_name;
				self.user.type = 'App\\Models\\Bms\\Auth\\User';
				self.user.init();

				// Conversations
				angular.forEach(responses.conversations.data.conversations, (item, key) => {
					// Add Conversation
					let conversation = new Conversation();
					conversation.id = item.id;
					conversation.type = item.type;
					conversation.active = item.active;
					conversation.name = item.name;
					conversation.hasOnlineUsers = true;
					conversation.createdAt = item.created_at;
					conversation.updatedAt = item.updated_at;
					if (!item.total_pages <= 1) {
						conversation.nextPage = false;
					}

					// Add Users
					angular.forEach(item.users, (item, key) => {
						let user = new ChatUser();
						user.id = item.id;
						user.name = item.name;
						user.type = item.type;
						user.init();
						self.users.push(user);
						conversation.users.push(user);
						// Set Conversation Name
						conversation.name = user.name;
					});

					// Add Messages
					angular.forEach(item.messages, (item2, key) => {
						let message = new Message();
						message.id = Number(item2.id);
						message.userableId = Number(item2.userable_id);
						message.userableType = item2.userable_type;
						message.message = item2.message;
						message.createdAt = item2.created_at;
						message.read = !!item2.read;
						message.wasSentByCurrentUser =
							message.userableId === self.user.id
							&& message.userableType === self.user.type;
						message.init();
						conversation.messages.unshift(message);
					});

					// Init and add chat
					conversation.init();
					self.conversations.push(conversation);

					// Prep conversation
					self.conversation = conversation;
					self.activeView = 'conversation';
					if (conversation.messages.length > 0) {
						self.visible = true;
						self.expanded = true;
					}

					updateConversationScroll();
					markActiveConversationMessagesRead();
					Focus('conversation-message');
				});

				updateTotalUnreadMessageCount();

				AuthService.getUser().then((user) => {
					// Join private channel
					echo.private('App.User.' + user.id)
						.listen('OnlineFranchiseUsers', function (e) {
							// OnlineFranchiseFactory.updateOnlineFranchiseUsers(e.users);
						})
						.listen('FranchiseConversationDeactivated', function (data) {
							let conversation = $filter('filter')(
								self.conversations,
								{
									id: data.conversation.id
								},
								true
							)[0];
							removeConversation(conversation);
						})
						.listen('FranchiseMessageReceived', function (data) {
							$scope.$apply(() => {
								self.visible = true;
								self.expanded = true;
							});
							let conversation = $filter('filter')(
								self.conversations,
								{
									id: Number(data.message.conversation_id)
								},
								true
							)[0];
							if (conversation !== undefined) {
								let message = new Message();
								message.id = data.message.id;
								message.userableId = Number(data.message.userable_id);
								message.userableType = data.message.userable_type;
								message.message = data.message.message;
								message.read = true;
								message.wasSentByCurrentUser =
									message.userableId === self.user.id
									&& message.userableType === self.user.type;
								message.createdAt = data.message.created_at;
								message.init();
								$scope.$apply(() => {
									conversation.messages.push(message);
									conversation.updateLastMessage();
									conversation.updatedAt = message.createdAt;
									if (self.expanded &&
										(
											self.conversation !== null &&
											data.message.conversation_id === self.conversation.id
										)
									) {
										self.conversation.updateLastMessage();
										markActiveConversationMessagesRead();
										if (!document.hasFocus()) {
											// notificationMessage(message, conversation);
										}
									} else {
										// notificationMessage(message, conversation);
									}
									updateConversationScroll();
									conversation.updateUnreadMessageCount();
									updateTotalUnreadMessageCount();
								});
							}

						})
						.listen('FranchiseConversationCreated', function (data) {
							// Add conversation
							let conversation = new Conversation();
							conversation.id = data.conversation.id;
							conversation.type = data.conversation.type;
							conversation.active = data.conversation.active;
							conversation.name = data.conversation.name;
							conversation.hasOnlineUsers = true;
							conversation.createdAt = data.conversation.created_at;
							conversation.updatedAt = data.conversation.updated_at;
							if (!data.conversation.total_pages <= 1) {
								conversation.nextPage = false;
							}

							// Add users
							angular.forEach(data.conversation.users, (item, key) => {
								let user = new ChatUser();
								user.id = item.id;
								user.name = item.name;
								user.type = item.type;
								user.init();
								self.users.push(user);
								conversation.users.push(user);
								// Set Conversation Name
								conversation.name = user.name;
							});

							// Init and add chat
							conversation.init();
							self.conversations.push(conversation);

							// Prep conversation
							self.conversation = conversation;
							self.activeView = 'conversation';
							updateConversationScroll();
							markActiveConversationMessagesRead();
							Focus('conversation-message');
						});
					// Join presence channel
					echo.join('bms')
						.here(function (users) {
						})
						.joining(function (user) {
						})
						.leaving(function (user) {
						});
				});


			}, function (errors) {
				// TODO: Errors
				console.error('init() $q.all(promises) Errors', errors);
			});

		}

		// Conversation ------------------------------------------------------------------------------------------------
		function updateTotalUnreadMessageCount() {
			let count = 0;
			angular.forEach(self.conversations, function (conversation, key) {
				conversation.updateUnreadMessageCount();
				count += conversation.unreadMessageCount;
			});
			self.totalUnreadMessageCount = count;
		}

		function updateConversationScroll() {
			$timeout(function () {
				let scroller = document.getElementById('conversation-main');
				scroller.scrollTop = scroller.scrollHeight;
			}, 0, false);
		}

		function markActiveConversationMessagesRead() {
			if (
				self.conversation !== null &&
				!!self.conversation.id &&
				self.conversation.lastMessage !== null &&
				self.conversation.lastMessage !== undefined
			) {
				angular.forEach(self.conversation.messages, function (message, key) {
					message.read = true;
				});
				self.conversation.updateUnreadMessageCount();
				updateTotalUnreadMessageCount();
				InstantMessagingRepository.markMessagesRead({
					conversationId: self.conversation.id,
					lastMessageId: self.conversation.lastMessage.id,
				});
			}
		}

		function sendMessageToConversation(conversation, message) {
			self.conversation.messageSending = true;
			InstantMessagingRepository.sendMessage({
				conversationId: conversation.id,
				message: message,
			}).then(function () {
				self.conversation.messageSending = false;
				self.conversation.messageToSend = null;
				Focus('conversation-message');
			});
		}

		function removeConversation(conversation) {
			if (conversation.messages.length > 0) {
				notify({
					message: 'Franchise chat with ' + conversation.name + ' has been closed by the other user.'
				});
			}
			$scope.$apply(() => {
				self.visible = false;
				self.expanded = false;
			});
			conversation.active = false;
			self.conversations.splice(self.conversations.indexOf(conversation), 1);
		}

		// Events ------------------------------------------------------------------------------------------------------
		$rootScope.$on('authLogOut', function (event) {
			echo.disconnect();
		});

		// Handlers ----------------------------------------------------------------------------------------------------
		handlers.expandClick = () => {
			self.expanded = !self.expanded;
		};

		handlers.minimiseClick = () => {
			self.expanded = !self.expanded;
		};

		handlers.messageKeyUp = ($event) => {
			if ($event.keyCode === 13 && self.conversation.messageToSend) {
				sendMessageToConversation(self.conversation, self.conversation.messageToSend);
			}
		};

		handlers.messageSendClick = () => {
			if (self.conversation.messageToSend) {
				sendMessageToConversation(self.conversation, self.conversation.messageToSend);
			}
		};
	}
})();